import { skipToken, useQuery } from '@tanstack/react-query';

import { useIamApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';
import useServiceAppState from './useServiceAppState';

import type { AxiosError } from 'axios';
import type { FetchDomainDetailInfoResParams } from '../constants';

type UseDomainDetailInfoProps = {
  /**
   * true 일 때, useQuery의 queryFn를 설정합니다.
   * - 기본값은 false 입니다.
   */
  revalidate?: boolean;
};

/**
 * GET /api/v1_1/domains/{domain_id} API를 호출하여 조직 상세 정보를 조회하는 훅입니다.
 * @description
 * - IAM Api의 응답값을 react-query로 제공합니다.
 * - SSR을 지원하고 있습니다.
 * - revalidate props를 지원합니다. `true` 일 때, useQuery의 queryFn를 설정합니다.
 */
const useDomainDetailInfo = (props: UseDomainDetailInfoProps) => {
  const { revalidate = false } = props;
  const {
    state: { domainId },
  } = useServiceAppState();
  const { fetchDomainDetailInfo } = useIamApiInstance();

  return useQuery<FetchDomainDetailInfoResParams, AxiosError<unknown, any>>({
    queryKey: [HOST_QUERY_KEY.GET_IAM_DOMAIN_DETAIL_INFO, { domainId }],
    queryFn: revalidate ? () => fetchDomainDetailInfo({ domainId }) : skipToken,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export default useDomainDetailInfo;

export type { UseDomainDetailInfoProps };
